// «سایت»ِ ملک از OpenStreetMap — خیابان‌ها و ساختمان‌های اطرافِ لوکیشنِ دقیقِ ملک، برای ساختنِ نمای بیرون و
// منظره‌ی پشتِ پنجره‌ها. فعلاً کاملاً سمتِ کاربر: مرورگرِ خودِ کاربر از Overpass API (سرویسِ جست‌وجوی داده‌ی
// OpenStreetMap) می‌پرسد و نتیجه را در localStorage نگه می‌دارد تا دفعه‌ی بعد دوباره گرفته نشود.
// (بعداً همین تابع می‌تواند به‌جای Overpass از سرورِ خودِ پروژه بخواند، بدونِ تغییرِ بقیه‌ی کد.)
//
// خروجی به «سانتی‌متر» و در همان دستگاهِ مختصاتِ سه‌بعدی است: مبدأ = لوکیشنِ ملک، +x = شرق، +z = جنوب
// (در پلان بالای صفحه = شمال، پس y پلان = z صحنه به سمتِ جنوب زیاد می‌شود).

// ترتیب مهم است: سرورِ mail.ru از ایران باز می‌شود (تستِ کاربر)؛ سرورِ اصلی (overpass-api.de) از ایران
// بسته است و فقط به‌عنوانِ آخرین امید می‌ماند. اگر هیچ‌کدام جواب نداد، از APIِ رسمیِ خودِ OpenStreetMap
// (api.openstreetmap.org — آن هم از ایران باز است) با یک محدوده‌ی مستطیلی خوانده می‌شود
const OVERPASS_ENDPOINTS = [
  'https://maps.mail.ru/osm/tools/overpass/api/interpreter',
  'https://overpass.kumi.systems/api/interpreter',
  'https://overpass-api.de/api/interpreter',
];
const OSM_API_MAP = 'https://api.openstreetmap.org/api/0.6/map';
const RADIUS_M = 220;
const REQUEST_TIMEOUT_MS = 20000;
const CACHE_PREFIX = 'kh-osm-site:v1:';
const EARTH_M_PER_DEG_LAT = 111320;

// عرضِ تقریبیِ خیابان (متر) وقتی خودِ داده عرض/تعدادِ لاین ندارد
const DEFAULT_ROAD_WIDTH_M = {
  motorway: 22,
  trunk: 20,
  primary: 16,
  secondary: 13,
  tertiary: 10,
  unclassified: 8,
  residential: 8,
  living_street: 6,
  service: 5,
  pedestrian: 6,
};
const ROAD_TYPES = new Set(Object.keys(DEFAULT_ROAD_WIDTH_M).concat(['motorway_link', 'trunk_link', 'primary_link', 'secondary_link', 'tertiary_link']));
const LEVEL_HEIGHT_M = 3.2;

function cacheKey(lat, lng) {
  return `${CACHE_PREFIX}${lat.toFixed(5)},${lng.toFixed(5)}`;
}

function readCache(key) {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function writeCache(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // حافظه پر یا غیرفعال — بدونِ کش ادامه می‌دهیم
  }
}

function buildQuery(lat, lng) {
  return `[out:json][timeout:25];
(
  way(around:${RADIUS_M},${lat},${lng})["highway"];
  way(around:${RADIUS_M},${lat},${lng})["building"];
);
out tags geom;`;
}

async function fetchTextWithTimeout(url) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  try {
    const res = await fetch(url, { signal: controller.signal });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.text();
  } finally {
    clearTimeout(timer);
  }
}

// پاسخِ XMLِ APIِ رسمیِ OSM (nodeها و wayها جدا) → همان شکلِ پاسخِ Overpass (way با geometry)، تا بقیه‌ی
// کد فقط یک قالب را بشناسد
function osmXmlToOverpassJson(xmlText) {
  const doc = new DOMParser().parseFromString(xmlText, 'application/xml');
  const nodes = new Map();
  doc.querySelectorAll('node').forEach((n) => {
    nodes.set(n.getAttribute('id'), { lat: parseFloat(n.getAttribute('lat')), lon: parseFloat(n.getAttribute('lon')) });
  });
  const elements = [];
  doc.querySelectorAll('way').forEach((w) => {
    const tags = {};
    w.querySelectorAll('tag').forEach((t) => {
      tags[t.getAttribute('k')] = t.getAttribute('v');
    });
    if (!tags.highway && !tags.building) return;
    const geometry = [];
    w.querySelectorAll('nd').forEach((nd) => {
      const n = nodes.get(nd.getAttribute('ref'));
      if (n) geometry.push(n);
    });
    elements.push({ type: 'way', id: Number(w.getAttribute('id')), tags, geometry });
  });
  return { elements };
}

async function fetchFromOsmApi(lat, lng) {
  const dLat = RADIUS_M / EARTH_M_PER_DEG_LAT;
  const dLng = RADIUS_M / (EARTH_M_PER_DEG_LAT * Math.cos((lat * Math.PI) / 180));
  const bbox = [lng - dLng, lat - dLat, lng + dLng, lat + dLat].map((v) => v.toFixed(6)).join(',');
  const xml = await fetchTextWithTimeout(`${OSM_API_MAP}?bbox=${bbox}`);
  return osmXmlToOverpassJson(xml);
}

async function fetchWithTimeout(url, body) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  try {
    // GET (همان شکلی که کاربر در مرورگر تست کرد و باز شد) — بدونِ هدرِ اضافه، تا درخواستِ CORSِ ساده بماند
    const res = await fetch(`${url}?data=${encodeURIComponent(body)}`, { signal: controller.signal });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } finally {
    clearTimeout(timer);
  }
}

function parseNumber(v) {
  if (v == null) return null;
  const n = parseFloat(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

// OSM (درجه) → سانتی‌متر نسبت به لوکیشنِ ملک (+x شرق، +z جنوب)
function makeProjector(lat0, lng0) {
  const mPerDegLng = EARTH_M_PER_DEG_LAT * Math.cos((lat0 * Math.PI) / 180);
  return (lat, lng) => [(lng - lng0) * mPerDegLng * 100, -(lat - lat0) * EARTH_M_PER_DEG_LAT * 100];
}

function pointInPolygon(x, z, pts) {
  let inside = false;
  for (let i = 0, j = pts.length - 1; i < pts.length; j = i, i += 1) {
    const [xi, zi] = pts[i];
    const [xj, zj] = pts[j];
    if (zi > z !== zj > z && x < ((xj - xi) * (z - zi)) / (zj - zi) + xi) inside = !inside;
  }
  return inside;
}

// تبدیلِ پاسخِ خامِ Overpass به ساختارِ سبکِ خودمان
export function parseOverpass(json, lat0, lng0) {
  const project = makeProjector(lat0, lng0);
  const roads = [];
  const buildings = [];
  (json?.elements || []).forEach((el) => {
    if (el.type !== 'way' || !Array.isArray(el.geometry) || el.geometry.length < 2) return;
    const tags = el.tags || {};
    const points = el.geometry.map((g) => project(g.lat, g.lon));
    if (tags.building) {
      if (points.length < 4) return;
      const levels = parseNumber(tags['building:levels']);
      const heightM = parseNumber(tags.height);
      buildings.push({
        id: el.id,
        points,
        levels: levels != null ? Math.round(levels) : null,
        heightCm: heightM != null ? heightM * 100 : levels != null ? levels * LEVEL_HEIGHT_M * 100 : null,
      });
      return;
    }
    const type = tags.highway;
    if (!ROAD_TYPES.has(type)) return;
    const baseType = type.replace('_link', '');
    const widthM =
      parseNumber(tags.width) ||
      (parseNumber(tags.lanes) ? parseNumber(tags.lanes) * 3.2 : null) ||
      DEFAULT_ROAD_WIDTH_M[baseType] ||
      8;
    roads.push({ id: el.id, type, name: tags.name || '', points, widthCm: widthM * 100, oneway: tags.oneway === 'yes' });
  });
  // ساختمانِ خودِ ملک: ساختمانی که پین داخلش افتاده
  const own = buildings.find((b) => pointInPolygon(0, 0, b.points)) || null;
  if (own) own.isOwn = true;
  return { roads, buildings, ownBuildingId: own ? own.id : null };
}

// می‌گیرد (اول از کش) — site: { lat, lng }. خروجی: { roads, buildings, ownBuildingId, source } یا خطا
export async function fetchSiteContext(site) {
  // خاموش: نمای اطرافِ ملک دیگر لازم نیست، پس هیچ داده‌ای نمی‌گیریم و هیچ درخواستی به سرورهای خارجی نمی‌رود
  return { roads: [], buildings: [], ownBuildingId: null, source: 'off' };
  if (!site || !Number.isFinite(site.lat) || !Number.isFinite(site.lng)) throw new Error('no-site');
  const key = cacheKey(site.lat, site.lng);
  const cached = readCache(key);
  if (cached) return { ...cached, source: 'cache' };
  // اول از سرورِ خودمان (پایگاه‌داده‌ی ساختمان و خیابانِ تهران)؛ اگر آنجا داده نبود، از Overpass/OSM
  try {
    const res = await fetch(`/api/site-context?lat=${site.lat}&lng=${site.lng}&r=${RADIUS_M}`);
    if (res.ok) {
      const json = await res.json();
      if (json.elements && json.elements.length) {
        const parsed = parseOverpass(json, site.lat, site.lng);
        writeCache(key, parsed);
        return { ...parsed, source: 'server' };
      }
    }
  } catch (e) {
    /* ادامه با منبعِ بعدی */
  }
  const query = buildQuery(site.lat, site.lng);
  let lastError = null;
  for (let i = 0; i < OVERPASS_ENDPOINTS.length; i += 1) {
    try {
      const json = await fetchWithTimeout(OVERPASS_ENDPOINTS[i], query);
      const parsed = parseOverpass(json, site.lat, site.lng);
      writeCache(key, parsed);
      return { ...parsed, source: 'network' };
    } catch (e) {
      lastError = e;
    }
  }
  try {
    const json = await fetchFromOsmApi(site.lat, site.lng);
    const parsed = parseOverpass(json, site.lat, site.lng);
    writeCache(key, parsed);
    return { ...parsed, source: 'osm-api' };
  } catch (e) {
    lastError = e;
  }
  throw lastError || new Error('osm-unreachable');
}

// مسیرِ یک خیابان: نزدیک‌ترین نقطه روی خیابان به (x, z) و فاصله‌اش — برای پیدا کردنِ «خیابانِ جلوی ملک»
export function nearestPointOnPolyline(points, x, z) {
  let best = null;
  for (let i = 0; i < points.length - 1; i += 1) {
    const [x1, z1] = points[i];
    const [x2, z2] = points[i + 1];
    const dx = x2 - x1;
    const dz = z2 - z1;
    const len2 = dx * dx + dz * dz;
    const t = len2 > 0 ? Math.max(0, Math.min(1, ((x - x1) * dx + (z - z1) * dz) / len2)) : 0;
    const px = x1 + dx * t;
    const pz = z1 + dz * t;
    const d = Math.hypot(x - px, z - pz);
    if (!best || d < best.dist) best = { x: px, z: pz, dist: d, segIndex: i, dirX: dx, dirZ: dz };
  }
  return best;
}
